import { DEMO_PATH_PREFIX, PATHS } from '../config';

import { hasDemoPathPrefix } from './demoSession';

export const redirectToSignIn = () => {
  const { origin, pathname } = window.location;
  // SignIn passes redirectTo to navigate(), which adds the router basename.
  const base = hasDemoPathPrefix(pathname) ? DEMO_PATH_PREFIX : '';
  const redirectTo = base ? pathname.slice(base.length) || '/' : pathname;

  window.location.href = `${origin}${base}${PATHS.signIn}?redirectTo=${encodeURIComponent(redirectTo)}`;
};
